export default __webpack_public_path__ + "static/wbs-logo-white-ol-f3e84e08d29e9270fe19788c86a48e74.svg";